import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import ordersClient from "../../../api/order";

const useOrdersQuery = (query?: string) => {
  const queryClient = useQueryClient();
  const limit = 20;
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, ...rest } =
    useInfiniteQuery({
      queryKey: ["orders", query],
      queryFn: async ({ pageParam }) => {
        const { skip = 0 } = pageParam || {};
        const res = await ordersClient.textSearchOrders({
          query,
          skip,
          limit,
          populateGift: true,
        });

        res.forEach((order) => {
          queryClient.setQueryData(["order", order.id], order);
        });

        return res;
      },
      getNextPageParam: (lastPage, allPages) => {
        const currentLength = allPages.flat().length;
        return lastPage.length < limit ? undefined : { skip: currentLength };
      },
      initialPageParam: { skip: 0 },
    });

  const flatData = data?.pages.flat();

  return {
    data: flatData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    ...rest,
  };
};

export default useOrdersQuery;
